<template>
<div class="main-content" id="panel">
   <div class="header bg-primary pb-6">
      <div class="container-fluid">
         <div class="header-body">
            <div class="row align-items-center py-4">
               <div class="col-lg-2 col-md-12 col-2 mb-3">
                  <h2>Executed Trades </h2>
               </div>
               <div class="col-lg-10 col-md-12 col-10 text-right bid">
                    <div class="input-group d-inline-flex justify-content-end">
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchHolding()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchHolding" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>
                    </div>
                </div>
            </div>
         </div>
      </div>
   </div>
   <div class="container-fluid mt--6 filter-show">
        <div class="card w-100 p-2 mb-2  d-inline-block">
      <div class="d-flex justify-content-between">
         <h5 class="ml-3">Filters</h5>
         <span class="btn btn-link" @click="showFilters = !showFilters">
         <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
         </span>
      </div>
      <div class="row" v-if="showFilters">
         <div class="col-lg-12">
            <form class="row">
               <div class="col-md-6 col-lg-3">
                  <label for="filter" class="col-form-label">From</label>
                  <datepicker v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
               </div>
               <div class="col-md-6 col-lg-3">
                  <label for="filter" class="col-form-label">To</label>
                  <datepicker v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
               </div>
               <div class="col-md-4 col-lg-3">
                  <label for="filter" class="col-form-label">Accounts</label>
                  <multiselect 
                     v-model="filterAccounts" 
                     placeholder="Select" 
                     label="account" 
                     track-by="accountMappingId" 
                     :options="accountList" 
                     :multiple="true" 
                     :limit="4"  ></multiselect>
               </div>
               <div class="col-md-4 col-lg-3">
                  <label for="filter" class="col-form-label">Cusips</label>
                  <multiselect 
                     v-model="filterCusips" 
                     placeholder="Select" 
                     :options="cusipList" 
                     :multiple="true" 
                     :limit="3"  ></multiselect>
               </div>
               <div class="col-md-6 col-lg-3">
                     <label for="filter" class="col-form-label">Status</label>
                     <multiselect 
                        v-model="filterStatus" 
                        placeholder="Select"  
                        :options="statusList" 
                        :multiple="true" 
                        :limit="4"
                          >
                     </multiselect>
               </div>
               <div class="col-md-4 col-lg-3">
                  <div class="form-check mt-5">
                     <input id="checkbox2" type="checkbox"  class="form-check-input wh" v-model="isEmailSent" >
                     <label for="checkbox2" class="form-check-label">Email Sent</label>
                  </div>
               </div>
               <div class="col-md-12 text-center">
                  <button @click="clearFilter()" type="button" class="btn btn-secondary rounded">Clear</button>
                  <button :disabled="!fromDate || !toDate" @click="searchHolding()" type="button" class="btn btn-primary rounded">Filter</button>
               </div>
            </form>
         </div>
      </div>
        </div>
   </div>
   <div class="container-fluid">
      <div class="row xsOnly">
         <div class="col-xl-12">
            <div class="card scrollbar vh-75" id="scroll">
               <div class="table-responsive">
                  <table class="table align-items-center table-flush table-hover bidtbl bid-acc">
                     <thead class="thead-light psticky">
                        <tr >
                           <!-- <th 
                              scope="col" 
                              class="sort text-left"
                              >CUSTOMER <br>ACCOUNT | TYPE</th> -->
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >CUSIP</th>
                           <!-- <th
                              scope="col"
                              class="sort text-center"
                              >BOUGHT
                           </th> -->
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >COST</th>
                           <!-- <th 
                              scope="col" 
                              class="sort text-center"
                              >CLOSING PX</th> -->
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >TRADER/ADMIN</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >OPERATOR</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >SELL QTY</th>
                              <th 
                              scope="col" 
                              class="sort text-center"
                              >EXECUTED BY</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >EXECUTED ECN</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >EXECUTED QTY</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >EXECUTED PRICE</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >EXECUTED TIME</th>
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >TICKET SPREAD</th> 
                           <!-- <th 
                              scope="col" 
                              class="sort text-center"
                              >SPREAD</th>      -->
                           <!-- <th 
                           scope="col" 
                           class="sort text-center"
                           >HOLDINGS</th>  -->
                           <th 
                              scope="col" 
                              class="sort text-center"
                              >ACTION</th>
                        </tr>
                     </thead>
                     <tbody class="list">
                        <tr v-if="totalRows == 0 && !loading">
                           <td>
                              <p class="nodata">No data available</p>
                           </td>
                        </tr>
                        <tr v-for="holding in holdingsList" :key="holding.id"  >
                           <!-- <td class="text-left">
                              <span class="text-primary">{{holding.customerFirstName ? holding.customerFirstName[0] : ""}} {{holding.customerLastName}}</span><br>
                              <span>{{holding.accountVal}}</span> | 
                              <span class="text-success">{{holding.accountType}}</span> 
                           </td> -->
                           <td class="text-center">
                              <span class="cusips">{{holding.cusipVal}}</span><br>
                           </td>
                           <!-- <td class="text-center">
                              <span>{{holding.boughtDate ? moment(holding.boughtDate).format("MM/DD/YYYY") : 'N/A'}}</span><br>
                           </td> -->
                           <td class="text-center">
                              <span class="text-success">{{holding.cost | currency}}</span><br>
                           </td>
                           <!-- <td class="text-center">
                              <span class="text-danger">{{holding.closingPx}}</span><br>
                           </td> -->
                           <td class="text-center">
                              <span>{{holding.traderFirstName}} {{holding.traderLastName}}</span><br>
                           </td>
                           <td class="text-center">
                              <span>{{holding.operatorFirstName}} {{holding.operatorLastName}}</span>
                              
                              <!-- <span class="text-success" v-if="holding.operatorCognitoSub === cognitoSub">Me</span> -->
                           </td>
                           <td class="text-center">
                              <span>{{holding.sellQuantity}}</span>
                           </td>
                           <td class="text-center"><span>{{holding.bidAcceptedUserName}}</span></td>
                           <td class="text-center"><span>{{holding.successEcn}}</span></td>
                           <td class="text-center"><span>{{holding.executedQuantity}}</span></td>
                           <td class="text-center"><span>{{holding.executedPrice | currency}}</span></td>
                           <td class="text-center">{{holding.executedAt ? moment.utc(holding.executedAt).tz('America/New_York').format("MM/DD/YYYY hh:mm:ss a") : 'N/A'}} EST</td>
                           <td class="text-center">{{holding.ticketSpread}}</td>
                           <!--  <td class="text-center">{{holding.spread ? holding.spread.toFixed(3) : ""}}</td> -->
                           <td class="text-center invt">
                              <a @click="toggleViewHoldingModalOpen(holding.bidWantedInventoryListDto)" class="btn ibtn btn-outline-primary" title="Holding"><i class="far fa-user"></i></a>
                              <div class="d-inline-flex">
                                 <div class="dropdown">
                                    <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                       <button type="button" @click="emailBid(holding)" class="dropdown-item" title="Email"><span class="far fa-envelope mr-1"></span> <div>Email ticket</div></button>
                                       <button type="button" @click="downloadBid(holding)" class="dropdown-item" title="Download"><span class="fas fa-download mr-1"></span> <div>Download ticket</div></button>
                                       <button type="button" @click="printBid(holding)" class="dropdown-item" title="Print"><span class="fas fa-print mr-1"></span> <div>Print ticket</div></button>
                                       <button type="button" v-if="!holding.isEmailSent" @click="selectedHolding = holding,toggleTicketModalOpen()" class="dropdown-item" title="update"><span class="fas fa-check mr-1"></span> <div>Update Ticket Spread</div></button>
                                       <button type="button" @click="toggleViewBidWantedModalOpen(holding);selectedHolding = holding" class="dropdown-item" title="BIDS"><span class="fas fa-calendar-day mr-1"></span><div>Bids</div></button>
                                       <button v-if="holding.status == 'SUCCESS'" type="button" @click="tradeCancel(holding)"  class="dropdown-item del"><span class="fas fa-times mr-1 mt-1"></span> Trade Cancel</button>
                                       
                                       <!-- <button type="button" @click="deleteBid(holding)"  class="dropdown-item del"><span class="fas fa-trash mr-1"></span> Delete</button> -->
                                    </div>
                                 </div>
                              </div>
                           </td>
                           <!-- <td class="text-center">
                              <button  @click="toggleViewBidWantedModalOpen(holding);selectedHolding = holding" type="button" class="btn btn-primary" >VIEW</button>
                              </td> -->
                        </tr>
                     </tbody>
                     <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                  </table>
                  <!-- Pagination-->
                  <b-pagination
                     class="mt-4"
                     :total-rows="totalRows"
                     v-model="currentPage"
                     :per-page="perPage"
                     @input="getHoldingList(currentPage)"
                     ></b-pagination>
                  <div class="total-records">
                     <span>Total Records : {{totalRows}}</span>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <ViewBidWanted v-bind:holding="selectedHolding" v-if="viewBidWantedModalOpen" @close="toggleViewBidWantedModalOpen()" />
      <TicketSpread v-bind:holding="selectedHolding" v-bind:moduleName="'BIDACCUMULATOR'" v-if="ticketModalOpen" @close="toggleTicketModalOpen()" />
      <ViewHoldings  v-bind:holding="holdingsInBidWanted" v-if="viewHoldingModalOpen" @close="toggleViewHoldingModalOpen()" />
   
   </div>
</div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import ViewBidWanted from './ba-common/BaViewBidWantedModal';
import Datepicker from 'vuejs-datepicker';
import TicketSpread from "@/components/common/UpdateTicketSpreadModal";
import ViewHoldings from './ba-common/BaViewHoldingListModal';

export default {
  name: "baAllHoldingsTrader",
  components : {
    ViewBidWanted,
    Datepicker,
    TicketSpread,
    ViewHoldings
  },
  data() {
    return {
        loading : false,
        currentPage: 1,
        perPage: 20,
        searchValue : "",
        sortColumn: "id",
        sortOrder:"ASC",
        totalRows : 0,
        viewBidWantedModalOpen : false,
        holdingsList : [],
        selectedHolding : null,
        cognitoSub : authService.getUser().cognitoSub,
        showFilters : false,
        fromDate : "",
        toDate : "",
        filterAccounts : [],
        accountList: [],
        filterCusips : [],
        cusipList : [],
        isEmailSent : false,
        ticketModalOpen : false,
        statusList : ['SUCCESS','BROUGHT_IN','DIRECT_ECN_SUCCESS'],
        filterStatus : [],
        viewHoldingModalOpen : false,
        holdingsInBidWanted : []

    };
  },
  methods: {
   toggleViewHoldingModalOpen(holdings){
      this.holdingsInBidWanted = holdings
      this.viewHoldingModalOpen = !this.viewHoldingModalOpen;
   },
   toggleTicketModalOpen(){
      this.ticketModalOpen = !this.ticketModalOpen;
      if(!this.ticketModalOpen){
         this.getHoldingList(); 
      }
   },
    searchHolding(){
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.currentPage = 1;
      this.getHoldingList(); 
    },
    clearFilter(){
      this.fromDate = this.moment().format("MM-DD-YYYY");
      this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
      this.filterAccounts = [];
      this.filterCusips = [];
      this.isEmailSent = false;
      this.filterStatus = [];
      this.getHoldingList();
    },
    printBid(bid){
        let routeData = this.$router.resolve({
          name: "printticket",
          query: {
            bidId: bid.id,
            isInventory : bid.isInventory
          }
        });
        window.open(routeData.href, "_blank");
    },
    tradeCancel(bid){
      var message = "Are you sure you want to cancel this trade?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
            "bidWantedId":bid.id,
            "cognitoSub": authService.getUser().cognitoSub,
            "client":"drl"}
          this.$http
          .post(config.baseUrlAutoBidder + "/bidwanted/trade-cancel",data,auth)
          .then(() => {
            this.loading = false;              
            this.getHoldingList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
    deleteBid(bid){
      var message = "Are you sure you want to delete this trade?";
      this.$confirm(message,"","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
        //   let data = {
        //           "id":bid.id,
        //           "status":"DELETED"
        //       }
          this.$http
          .put(config.baseUrlBidSide + "/bidwanted/delete?bidWantedId="+bid.id,'',auth)
          .then(() => {
            this.loading = false;              
            this.getHoldingList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
    emailBid(bid){
        var message = null;
        if(bid.isEmailSent){
            message = "Email already sent, are you sure want to send it again?";
        }else{
            message = "Are you sure you want to email this trade?";
        }
        this.$confirm(message,"Email","question",{confirmButtonText:"SEND",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .post(config.baseUrlBidSide + "/bidwanted/ticket-email?bidWantedId="+bid.id,'',auth)
            .then(() => {
                this.loading = false;
                this.$alert("Email sent successfully","","success")              
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    downloadBid(bid){
        var message = "Are you sure you want to download this trade?";
        this.$confirm(message,"Download","question",{confirmButtonText:"DOWNLOAD",cancelButtonText : "No"}).then(() => {
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken()  }
            };
            this.$http
            .get(config.baseUrlBidSide + "/bidwanted/ticket-download?bidWantedId="+bid.id,auth)
            .then((response) => {
                this.loading = false;
                //console.log("file",response.data)
                response.data.urls.forEach(file => {
                window.open(file, "_blank");
                })   
            })
            .catch(() => {
                this.loading = false;              
            });
        });

    },
    getHoldingList(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        var status = this.filterStatus.length > 0 ? this.filterStatus.toString() : this.statusList.toString();
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            status+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate+
            "&accountMappingIds="+
            this.filterAccounts.map((e) => {return e.accountMappingId}).toString()+
            "&isEmailSent="+
            this.isEmailSent+
            "&cognitoSub=" +
            authService.getUser().cognitoSub+
            "&cusips="+
            this.filterCusips.toString(),
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.holdingsList = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    toggleViewBidWantedModalOpen(){
      this.viewBidWantedModalOpen = !this.viewBidWantedModalOpen;
    },
   getAllAccountList(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
        config.baseUrlBidSide +
            "/inventory/account-map-list",
            auth
        )
        .then(result => {
          this.accountList = result.data;
        })
    }, 
   getTradeCusipList(){
       const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
        config.baseUrlBidSide +
            "/bidwanted/cusip-list?status=SUCCESS,BROUGHT_IN,DIRECT_ECN_SUCCESS",
            auth
        )
        .then(result => {
          this.cusipList = result.data;
        })

    }
  },
  mounted() {
    this.fromDate = this.moment().format("MM-DD-YYYY");
    this.toDate = this.moment().add(1,'days').format("MM-DD-YYYY");
    this.getTradeCusipList();
    this.getAllAccountList();
    this.getHoldingList();


  }
};
</script>
<style scoped>
.dropdown-item div {
   margin-top: -2px;
}
</style>